import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNotAdmin: NavigationGuard = () => {
  if (useAuthStore().isUserAdmin) {
    return true;
  } else {
    return { name: 'home' };
  }
};
